import React from 'react';
import { getLatestScenes, getLibraryClipCount } from '../../actions/search';
import { MARKETING_NAV_LINKS } from '../../constants';
import Layout from '../../components/Layout';
import Home from './Home';

async function action(context) {
  // Do not need the results here, just warming up the results ASAP.
  await Promise.all([
    context.store.dispatch(getLatestScenes()),
    context.store.dispatch(getLibraryClipCount()),
  ]);

  return {
    chunks: ['marketing'],
    title:
      'Storytape - One subscription. Unlimited 4K stock footage video clips.',
    description:
      'Storytape is an unlimited stock footage platform. Each month we add more than 500+ new 4K video clips. Browse the full cinematic library for free.',
    component: (
      <Layout
        transitionId="home"
        showHeader={true}
        headerNavLinks={MARKETING_NAV_LINKS}
      >
        <Home />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/home/index.js